// extracted by mini-css-extract-plugin
module.exports = {"error":"_6c97079b1b--error--3CSxV","button":"_6c97079b1b--button--1ntQy"};